import { useEffect, useState } from 'react';
import Input from '../../components/Input';
import Card from '../../components/Card';
import Stack from '../../components/Stack';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Button from '../../components/Button'


import { createCompetition, fetchAdminCompetition, updateAdminCompetition } from '../../api/admin/api';
import Checkbox from '../../components/Checkbox';
import FlashMessage from '../../components/FlashMessage';
import { set } from 'date-fns';

export default function CreateCompetitionForm() {
  const [name, setName] = useState('');
  const [teamSize, setTeamSize] = useState('');
  const [rookieCount, setRookieCount] = useState('');
  const [veteranCount, setVeteranCount] = useState('');
  const [includeAddress, setIncludeAddress] = useState(false);
  const [officeRestriction, setOfficeRestriction] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [status, setStatus] = useState(null);
  const [vivintCompetitionId, setVivintCompetitionId] = useState('');
  const [eventParticipationLimit, setEventParticipationLimit] = useState(false);
  const [type, setType] = useState('success')
  const navigate = useNavigate();
  const { editing, id } = useParams()
  const editingComp = editing === 'true'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Submitting...');

    const payload = {
      name,
      team_size: teamSize,
      rookie_count: rookieCount,
      veteran_count: veteranCount,
      include_address: includeAddress,
      event_participation_limit: eventParticipationLimit,
      office_restriction: officeRestriction,
      is_active: isActive,
      id: id,
      vivint_competition_id: vivintCompetitionId
    };

    let res;
    try {
      if(!editingComp ) {
        res = await createCompetition(payload);
      } else {
        res = await updateAdminCompetition(payload)
      }

      if (res && !editingComp) {
        setStatus('Created successfully');
        setType('success')
        resetForm();
        setTimeout(() => navigate('/admin/competitions'), 1000);
      } else if(res && editingComp) {
        setStatus('Updated successfully');
        setType('success')
        resetForm();
        setTimeout(() => navigate(`/admin/competitions/${id}`), 1000);
      } else {
        setStatus(`Failed to create`);
        setType('failure')
      }
    } catch (error) {
      setStatus(`Error: ${error.message}`);
      setType('failure')
    }
  };

  const resetForm = () => {
    setName('');
    setTeamSize('');
    setRookieCount('');
    setVeteranCount('');
    setVivintCompetitionId('')
    setIncludeAddress(false);
    setOfficeRestriction(false);
    setIsActive(true);
    setEventParticipationLimit(false);
  };

  useEffect(() => {
    if(editingComp) {
      fetchAdminCompetition(id)
        .then(res => {
          const {
            name,
            team_size,
            // setter_count,
            rookie_count,
            veteran_count,
            // division_split,
            // direct_to_home,
            include_address,
            event_participation_limit,
            // quarterly_competition,
            office_restriction,
            is_active,
            vivint_competition_id
          } = res

          setName(name)
          setTeamSize(team_size)
          // setSetterCount(setter_count)
          setRookieCount(rookie_count)
          setVeteranCount(veteran_count)
          // setDivisionSplit(division_split)
          // setDirectToHome(direct_to_home)
          setIncludeAddress(include_address)
          // setQuarterlyCompetition(quarterly_competition)
          setOfficeRestriction(office_restriction)
          setIsActive(is_active)
          setVivintCompetitionId(vivint_competition_id)
          setEventParticipationLimit(event_participation_limit)
        })
        .catch((err) => {
          setStatus(`Failed to Fetch Competition. ${err.message}`)
        })
    }
  }, [])

  return (
    <Card>
      <FlashMessage
        message={status}
        type={type}
        onClose={() => {console.log('do nothing')}}
      />
      <Stack align='start' justify='center' className='gap-4'>
        <Stack width="full" align='start' justify='center' className='py-6 gap-2 border-b'>
          <Header size='xl'>{editingComp ? 'Edit Competition' : 'Create New Competition'}</Header>
          <p className='text-sm'>Select all competition parameters</p>
        </Stack>

        <form className="w-full flex flex-col items-center gap-8" onSubmit={handleSubmit}>
          <Stack width='full' justify='start' align='start' className='gap-4'>
            {[
              { value: name, placeholder: 'Competition Name', type: 'text', setter: setName },
              { value: vivintCompetitionId, placeholder: 'Vivint Competition ID', type: 'number', setter: setVivintCompetitionId },
              { value: teamSize, placeholder: 'Team Size', type: 'number', setter: setTeamSize },
              { value: rookieCount, placeholder: 'Rookie Count', type: 'number', setter: setRookieCount },
              { value: veteranCount, placeholder: 'Veteran Count', type: 'number', setter: setVeteranCount },
            ].map(({ value, placeholder, type, setter }) => (
              <Input
                key={placeholder}
                value={value}
                placeholder={placeholder}
                type={type}
                onChange={(e) => setter(e.target.value)}
              />
            ))}

            <div className="w-auto max-w-full grid grid-cols-2 gap-y-6 gap-x-28 pt-4 text-sm text-black">
              {[
                { label: 'Include Address', checked: includeAddress, setter: setIncludeAddress },
                { label: 'Office Restriction', checked: officeRestriction, setter: setOfficeRestriction },
                { label: 'Is Active', checked: isActive, setter: setIsActive },
                { label: 'Event Participation Limit', checked: eventParticipationLimit, setter: setEventParticipationLimit },
              ].map(({ label, checked, setter }) => (
                <Checkbox
                  key={label}
                  label={label}
                  value={checked}
                  handleClick={setter}
                />
              ))}
            </div>
          </Stack>

          <Stack width='full' direction='row' justify='end' align='center'>
            <Button
              className='w-auto max-w-max py-2 px-14'
              type="submit"
            >
              {editingComp ? 'Update Competition' : 'Create Competition'}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Card>
  );
}
